import { useCallback, useId, useRef } from "react";
import Modal from "../components/UI/Modal";
import Button from "../components/UI/Button";

const OK = "ok";
const CANCEL = "cancel";

export function useConfirm() {
  const modalRef = useRef();
  const id = useId();
  const inputRef = useRef();
  const openModal = useCallback((input) => {
    modalRef.current.open();
    inputRef.current = input;
  }, []);

  const confirm = useRef(({ children, onAnswer, ...props }) => (
    <Modal
      noBackdropClose
      key={id}
      {...props}
      ref={modalRef}
      onDialogSubmit={(returnValue) => {
        if (returnValue === OK) {
          onAnswer(true, inputRef.current);
        } else {
          onAnswer(false, inputRef.current);
        }
        inputRef.current = null;
      }}
      size={"mcw-lg"}
    >
      <div className={"marginB10"}>{children}</div>
      <div className={"text-right"}>
        <Button
          onClick={() => modalRef.current.close(CANCEL)}
          type="button"
          variant="secondary"
        >
          Annuler
        </Button>
        <Button
          className={"marginL10 paddingL20 paddingR20"}
          onClick={() => modalRef.current.close(OK)}
          type="button"
          variant="primary"
        >
          OK
        </Button>
      </div>
    </Modal>
  ));

  // eslint-disable-next-line react-hooks/refs
  return [confirm.current, openModal];
}
